import { render } from "./CardItemRow.vue?vue&type=template&id=5dba3de4&ts=true"
import script from "./CardItemRow.vue?vue&type=script&lang=ts"
export * from "./CardItemRow.vue?vue&type=script&lang=ts"

import "./CardItemRow.vue?vue&type=style&index=0&id=5dba3de4&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__